import { useBlocker } from 'react-router';

import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/dialog';

export interface NavigationBlockerDialogProps {
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel?: string;
  enabled?: boolean;
  excludePaths?: string[];
  onProceed?: () => void;
}

export function NavigationBlockerDialog(navigationBlockerDialogProps: NavigationBlockerDialogProps) {
  const { title, description, confirmLabel, cancelLabel = 'Anuluj', enabled = true, excludePaths = [], onProceed } = navigationBlockerDialogProps;

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    if (!enabled) {
      return false;
    }
    const isExcludedPath: boolean = excludePaths.some((excludePath) => {
      const regexPattern: string = excludePath.replace(/:[^/]+/g, '[^/]+');
      return new RegExp(`^${regexPattern}$`).test(nextLocation.pathname);
    });
    if (isExcludedPath) {
      return false;
    }
    return currentLocation.pathname !== nextLocation.pathname;
  });

  const handleProceed = () => {
    onProceed?.();
    // `proceed` replays the blocked navigation itself, so don't navigate again.
    blocker.proceed?.();
  };

  return (
    <AlertDialog open={blocker.state === 'blocked'}>
      <AlertDialogContent className="sm:max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="p-4">
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </div>
        <AlertDialogFooter className="bg-card border-t">
          <AlertDialogCancel onClick={handleProceed}>{confirmLabel}</AlertDialogCancel>
          <AlertDialogAction onClick={() => blocker.reset?.()}>{cancelLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
